namespace TabAurous.Sales {
    export namespace ApprovalOutItemsService {
        export const baseUrl = 'Sales/ApprovalOutItems';

        export declare function Create(request: Serenity.SaveRequest<ApprovalOutItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalOutItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ApprovalOutReturnCheck(request: TransactionRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalOutItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/ApprovalOutItems/Create",
            Update = "Sales/ApprovalOutItems/Update",
            Delete = "Sales/ApprovalOutItems/Delete",
            Retrieve = "Sales/ApprovalOutItems/Retrieve",
            List = "Sales/ApprovalOutItems/List",
            CustomList = "Sales/ApprovalOutItems/CustomList",
            ApprovalOutReturnCheck = "Sales/ApprovalOutItems/ApprovalOutReturnCheck"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'ApprovalOutReturnCheck'
        ].forEach(x => {
            (<any>ApprovalOutItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
